import * as Sentry from '@sentry/browser';
const {REACT_APP_SENTRY} = process.env;
const useSentry = () => {

    /**
     * initSentry - init Sentry
     */
    const initSentry = () => {
        if (REACT_APP_SENTRY) {
            Sentry.init({
                dsn: REACT_APP_SENTRY
            });
        }
    };

    return {
        initSentry,
    };
};

export default useSentry;
